module.exports = __webpack_public_path__ + "static/media/adwords-logo.9efca775.svg";